var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfrastructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(-340 -4925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    width: 77,
    height: 77,
    transform: "translate(340 4925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NFT_Infrastructure",
    "data-name": "NFT Infrastructure",
    transform: "translate(355 4941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 41,
    height: 31,
    rx: 6,
    transform: "translate(3 14)",
    fill: "#8ebdeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    d: "M0,0H7A0,0,0,0,1,7,0V13.5A3.5,3.5,0,0,1,3.5,17h0A3.5,3.5,0,0,1,0,13.5V0A0,0,0,0,1,0,0Z",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    d: "M0,0H6A0,0,0,0,1,6,0V14a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    d: "M0,0H7A0,0,0,0,1,7,0V13.5A3.5,3.5,0,0,1,3.5,17h0A3.5,3.5,0,0,1,0,13.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(13)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    d: "M0,0H7A0,0,0,0,1,7,0V13.5A3.5,3.5,0,0,1,3.5,17h0A3.5,3.5,0,0,1,0,13.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(20)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    d: "M0,0H7A0,0,0,0,1,7,0V13.5A3.5,3.5,0,0,1,3.5,17h0A3.5,3.5,0,0,1,0,13.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(27)",
    fill: "#016dd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    d: "M0,0H6A0,0,0,0,1,6,0V14a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    d: "M0,0H7A0,0,0,0,1,7,0V13.5A3.5,3.5,0,0,1,3.5,17h0A3.5,3.5,0,0,1,0,13.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(40)",
    fill: "#016dd9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.48593b2caf8fc5aadac4148fbd0c9858.svg";
export { ForwardRef as ReactComponent };